export const COUNTRY_CODES = ['IT', 'SI'] as const;
export const FTL_VOLUME = 13.6;
export const FTL_WEIGHT = 24500;
export const LDM_WEIGHT = 1750;

export type CountryCode = typeof COUNTRY_CODES[number];

export type DeliveryType = 'economy' | 'standard' | 'express';

export type Countries = {
  [country: string]: {
    zoneZips: { [zone: string]: string[] };
    zoneLeadTimes: { [zone: string]: { [key in DeliveryType]: string } };
    prices: {
      zones: string[];
      space: { [volume: string]: number[] };
    };
  };
};

export type Place = {
  placeName: string;
  postalCode: string;
  countryCode: CountryCode;
};

export type LocationPlaces = {
  from?: Place;
  to?: Place;
};
